import './App.css';
import logoCalculadora from './imagenes/calculadora-logo.png'
import Boton from './componenetes/Boton';
import Pantalla from './componenetes/Pantalla';
import BotonClear from './componenetes/BotonClear';
import { useState } from 'react';
import { evaluate } from 'mathjs'

function App() {

  const [input, setInput] = useState('');
  
  const agregarInput = val => {
    setInput( input + val);
  };

  const calcularResultado = ()=> {
    if (input){
      setInput(evaluate(input));
    } else {
      alert('Por favor ingrese valores para realizar los cálculos.')
    }
  };

  return (
    <div className="App">
      <div className='logo-contenedor'>
        <img 
        src={logoCalculadora} 
        alt='logo de Calculadora'
        className='logo' />
      </div>
      <div className='contenedor-calculaldora'>
        <Pantalla input={input}/>
        <div className='fila'>
          <Boton manejarClic={agregarInput}>7</Boton>
          <Boton manejarClic={agregarInput}>8</Boton>
          <Boton manejarClic={agregarInput}>9</Boton>
          <Boton manejarClic={agregarInput}>-</Boton>
        </div>
        <div className='fila'>
          <Boton manejarClic={agregarInput}>4</Boton>
          <Boton manejarClic={agregarInput}>5</Boton>
          <Boton manejarClic={agregarInput}>6</Boton>
          <Boton manejarClic={agregarInput}>*</Boton>
        </div>
        <div className='fila'>
          <Boton manejarClic={agregarInput}>1</Boton>
          <Boton manejarClic={agregarInput}>2</Boton>
          <Boton manejarClic={agregarInput}>3</Boton>
          <Boton manejarClic={agregarInput}>+</Boton>
        </div>
        <div className='fila'>
          <Boton manejarClic={agregarInput}>0</Boton>
          <Boton manejarClic={agregarInput}>.</Boton>
          <Boton manejarClic={calcularResultado}>=</Boton>
          <Boton manejarClic={agregarInput}>/</Boton>
        </div>
        <div className='fila'>
          <BotonClear manejarClear={()=> setInput('')}>
            Clear
          </BotonClear>
        </div>
      </div>
    </div>
  );
}

export default App;
